__turbopack_context__.v({
  "className": "galmuri11_2be144d4-module___Y5ZEG__className",
});
